export default __webpack_public_path__ + "7f8ae05e9a632f5d3fc07ce303a16b32.png";